import React from 'react'

interface ProgressBarProps {
  currentStep: number
  totalSteps: number
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep, totalSteps }) => {
  const percentage = (currentStep / totalSteps) * 100

  return (
    <div className="w-full mb-8">
      <div className="text-sm mb-2" style={{ color: 'rgb(76,76,75)' }}>
        Step {currentStep} of {totalSteps}
      </div>
      <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full transition-all duration-300 ease-out"
          style={{ width: `${percentage}%`, backgroundColor: '#145F6B' }}
        />
      </div>
    </div>
  )
}

